import React, {Component} from 'react'
import moment from 'moment'

class Sample extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            daysOfActiveMonth: [],
        }
    
    }

    componentDidMount() {
        this.pr();
    }

    pr = () => {
        const days = [];
        let startOfMonth = moment().startOf('month');
        const endOfMonth = moment().endOf('month');

        var duration = moment.duration(endOfMonth.diff(startOfMonth));
        var diff = Math.round(duration.asDays());
        //console.log(startOfMonth, endOfMonth);

        //0: 일, 1: 월, 2: 화. 3: 수, 4: 목, 5: 금, 6: 토
        let i = 0;
        while (startOfMonth <= endOfMonth) {
            const toDay = startOfMonth.day();
            if (i === 0 && toDay > 0) {
                for (let k = toDay; k > 0 ; k--) {
                    days.push(moment().startOf('month').add(-k, 'days').format('YYYY-MM-DD'))
                }
            }
            //console.log(startOfMonth.format('YYYY-MM-DD'), startOfMonth.day())
            days.push(startOfMonth.format('YYYY-MM-DD'))
            startOfMonth.add(1, 'days');

            i++;
            if (i === diff && toDay < 6) {
                for (let k = 0; k < 6-toDay; k++) {
                    days.push(moment().endOf('month').add(k+1, 'days').format('YYYY-MM-DD'))
                }
            }
        }
        //console.log(diff, days);
        this.setState({
            daysOfActiveMonth: days
        })
    }

    render() {

        const {daysOfActiveMonth} = this.state;
        return (
            <>
            <table>
                <tr>
                    <td>SUN</td>
                    <td>MON</td>
                    <td>TUS</td>
                    <td>WED</td>
                    <td>THU</td>
                    <td>FRI</td>
                    <td>SAT</td>
                </tr>
                {
                    Array(daysOfActiveMonth.length/7).fill(1).map((el, i) =>
                        <tr>
                            <td>{Number(daysOfActiveMonth[i*7].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+1].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+2].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+3].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+4].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+5].substring(8, 10))}</td>
                            <td>{Number(daysOfActiveMonth[i*7+6].substring(8, 10))}</td>
                        </tr>
                    )
                }
            </table>
            </>
        )
    }
}

export default Sample
